// extracted by mini-css-extract-plugin
module.exports = {"ProductMediaGallery":"ProductMediaGallery_ProductMediaGallery__36dII","SliderImageHolder":"ProductMediaGallery_SliderImageHolder__dzVXT"};